<template v-if="this.open">
  <page-header-wrapper @back="back">
    <template v-slot:breadcrumb>
      {{ formTitle }}
    </template>
    <template v-slot:title>
      {{ formTitle }}
    </template>
    <div class="bg-white padding-lr"ref="container">
      <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" labelAlign="left" :model="form"
                    :rules="rules">
        <a-collapse v-model="activeKey">
          <a-collapse-panel key="1" :header="$t('店铺.基础信息')" class="goods-collapse">
            <a-row>
<!--              <a-col :span="12">
                <a-form-model-item :label="this.$t('店铺.店铺名称')" prop="shopName">
                  <a-input v-model="form.shopName" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('店铺.店铺名称')"/>
                </a-form-model-item>
              </a-col>-->
              <a-col :span="12">
                <a-form-model-item :label="$t('通用.按钮.选择运营公司')" >
                  <div @click="openProdSelect" style="width: 100px">
                    <a-button type="dashed" @click="openProdSelect" danger>
                      <span style="color: dodgerblue"> {{$t('通用.按钮.选择运营公司')}}</span>
                    </a-button>
                  </div>
                </a-form-model-item>
              </a-col>
<!--              <a-col :span="12">
                <a-form-model-item :label="this.$t('店铺.运营公司')" prop="nickName" >
                  <a-input v-model="form.nickName" :maxLength="255" disabled=""/>
                </a-form-model-item>
              </a-col>-->
            </a-row>
            <a-table v-if="this.form.goodsList.length>0 "
                     :loading="goodsLoading"
                     :scroll="{ x: '80%' }"
                     rowKey="id"
                     :size="tableSize"
                     :columns="goodsColumns"
                     :data-source="form.goodsList"
                     :pagination="false"
                     :bordered="tableBordered">
                  <span slot="operation" slot-scope="text, record">
                     <a @click="handleGoodsDelete(record.id)">
                        <a-icon type="delete" />{{$t('通用.按钮.删除')}}
                     </a>
                  </span>
            </a-table>
          </a-collapse-panel>
        </a-collapse>

        <a-divider></a-divider>
        <div class="bottom-control">
          <a-space>
            <a-button type="primary" :loading="submitLoading" @click="submitForm">
              {{ $t('通用.按钮.保存') }}
            </a-button>
            <a-button type="dashed" @click="cancel">
              {{ $t('通用.按钮.取消') }}
            </a-button>
          </a-space>
        </div>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl"/>
        </a-modal>
        <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
          <video style="width: 100%" :src="previewUrl" ref="myVideo"
                 :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
        </a-modal>
      </a-form-model>
    </div>
    <check-select-userindex ref="CheckSelectUserindex" @goodsSelect="indexGoodsModalSelect"></check-select-userindex>
  </page-header-wrapper>
</template>

<script>
import {getShop, addShop, updateShop} from '@/api/shop/shop'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject, uploadOss} from "@/api/tool/oss";
import Template from "@/views/sms/template";
import {allBrand} from "@/api/goods/brand";
import {listShopCategory} from "@/api/shop/shopCategory";
import {listShopQc} from '@/api/shop/shopQc'
import {listShopEntry} from '@/api/shop/shopEntry'
import events from "@/components/MultiTab/events";
import bus from "@/utils/bus";
import CheckSelectUserindex from "@/views/system/user/modules/CheckSelectUserindex";
// import CheckSelectUserindex from "@/views/goods/goods/modules/CheckboxSelectCompany";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    Template,
    CheckSelectUserindex,
    CustomDictTag,
  },
  data() {
    return {
      /*分类的回显*/
      categorySelected: [],
      goodsLoading: false,
      goodsColumns: [
        {
          title: '运营公司',
          dataIndex: 'nickName',
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'phoneNumber',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center'
        },
      ],
      categoryList: [{id: "0", categoryName: '', children: []}],
      shopQcList: [],
      timeOfEntryList: [],
      activeKey: [1, 2, 3, 4],
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,
        goodsList:[],

        shopName: null,
        operate:null,
        nickName:null,
        shopLogo: null,

        shopBackground: null,

        shopKeywords: null,
        businessTime:null,

        shopQc: null,

        timeOfEntry: null,

        shopAreap: null,

        shopAreac: null,

        shopAreax: null,

        shopAddress: null,

        longitude: null,

        latitude: null,

        shopDescription: null,

        kfPhone: null,

        companyType: null,

        settleType: null,

        shopType: null,

        shopRecommend: null,

        userId: null,

        categoryId: null,

        categoryListId: null,

        shopState: null,

        shopCloseInfo: null,

        shopCollect: null,

        attentionNum: null,

        shopAccount: null,

        settlementAccount: null,

        shopCreateTime: null,

        shopEndTime: null,

        goodsDescribeScore: null,

        shopDescribeScore: null,

        logisticsScore: null,

        shopScore: null,

        thatViews: null,

        kfAccount: null,

        alarmGoodsStock: null,

        alarmGoodsSkuStock: null,

        weatherBzj: null,

        moneyBzj: null,

        platformRatio: null,

        contactsName: null,

        contactsPhone: null,

        contactsEmail: null,

        contactsCardNo: null,

        contactsCardHand: null,

        contactsCardFront: null,

        contactsCardContrary: null,

        businessLicenceNumber: null,

        companyName: null,

        companyAreap: null,

        companyAreac: null,

        companyAreax: null,

        companyAddressDetail: null,

        socialCreditCode: null,

        authCertificate: null,

        businessSphere: null,

        businessLicenceNumberElectronic: null,

        bankCardNoType: null,

        settlementBankUserName: null,

        settlementBankAccountNumber: null,

        bankUserPhone: null,

        settlementBankAccountName: null,

        settlementBankName: null,

        settlementBankAddress: null,

        accountInstCity: null,

        accountInstProvince: null,

        createTime: null,

        remark: null,

        trademarkCertificate: null,

        shopProtocol: null,

        businessLicense: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        shopName: [
          {required: true, message: this.$t('店铺.店铺名称') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        shopLogo: [
          {required: true, message: this.$t('店铺.店铺logo') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        shopBackground: [
          {required: true, message: this.$t('店铺.店铺背景图') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        shopKeywords: [
          {required: true, message: this.$t('店铺.搜索店铺关键词') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        timeOfEntry: [
          {required: true, message: this.$t('店铺.入驻时长,外键') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        shopAddress: [
          {required: true, message: this.$t('店铺.详细地区') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        /*shopDescription: [
          {required: true, message: this.$t('店铺.店铺简介') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],*/
        companyType: [
          {required: true, message: this.$t('店铺.公司申请类型1.个人2.公司') + this.$t('通用.文本.不能为空'), trigger: 'change'}
        ],
        settleType: [
          {required: true, message: this.$t('店铺.入驻类型1.线上商家2.线下商家') + this.$t('通用.文本.不能为空'), trigger: 'change'}
        ],
        shopType: [
          {required: true, message: this.$t('店铺.是否自营 0：否 1：是') + this.$t('通用.文本.不能为空'), trigger: 'change'}
        ],
        shopRecommend: [
          {required: true, message: this.$t('店铺.是否推荐 0：否 1：是') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        userId: [
          {required: true, message: this.$t('店铺.店主id,外键 (user.id)') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        /*categoryId: [
          {required: true, message: this.$t('店铺.店铺分类id') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],*/
        shopState: [
          {required: true, message: this.$t('店铺.店铺状态，0关闭，1开启，2审核中') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        shopCloseInfo: [
          {required: true, message: this.$t('店铺.店铺关闭原因') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        shopCollect: [
          {required: true, message: this.$t('店铺.店铺收藏数量') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        attentionNum: [
          {required: true, message: this.$t('店铺.关注数量') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        shopAccount: [
          {required: true, message: this.$t('店铺.店铺账户余额') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
      }
    }
  },
  filters: {},
  created() {
    this.getCategoryList()
    this.getShopQcListList()
    this.getTimeOfEntryList()

  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
    this.form.id = this.$route.query.id
    if (this.form.id) {
      this.handleUpdate(this.form.id)
    } else {
      this.handleAdd()
    }
  },
  methods: {
    container() {
      return this.$refs.container;
    },
    back() {
      let pages = this.$store.pages;
      pages.indexOf(this.$route)
      events.$emit('close', pages.indexOf(this.$route))
      // 去更新列表页的数据
      bus.$emit('updateShopList')
      this.$router.push({path: '/shop/shop', replace: true, query:{}  })
    },
    openProdSelect() {
      this.$refs.CheckSelectUserindex.openGoods(undefined, this.form.goodsList, 10);
    },
    indexGoodsModalSelect(records) {
      this.form.operate = records[0].id
      this.form.nickName = records[0].nickName
      this.form.goodsList = records
      console.log('运营公司选择了',this.form.operate)
      console.log('运营公司选择了',this.form.nickName)
      console.log('运营公司选择了',this.form.goodsList)
    },
    limitPrice() {
      // console.log(i);
      let val = this.form.platformRatio.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val < 0) {
        val = ''
      }
      if (val > 50) {
        val = 50
      }
      this.form.platformRatio = val
    },
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset() {
      this.categorySelected = [];
      // this.shopQcList=[];
      this.formType = 1
      this.form = {
        id: null,
        goodsList:[],

        shopName: null,
        operate:null,
        nickName:null,
        shopLogo: null,
        shopBackground: null,
        shopKeywords: null,
        shopQc: null,
        timeOfEntry: null,
        shopAreap: null,
        shopAreac: null,
        shopAreax: null,
        shopAddress: null,
        longitude: null,
        latitude: null,
        shopDescription: null,
        kfPhone: null,
        companyType: null,
        settleType: null,
        shopType: null,
        shopRecommend: null,
        userId: null,
        categoryId: null,
        categoryListId: null,
        shopState: null,
        shopCloseInfo: null,
        shopCollect: null,
        attentionNum: null,
        shopAccount: null,
        settlementAccount: null,
        shopCreateTime: null,
        shopEndTime: null,
        goodsDescribeScore: null,
        shopDescribeScore: null,
        logisticsScore: null,
        shopScore: null,
        thatViews: null,
        kfAccount: null,
        alarmGoodsStock: null,
        alarmGoodsSkuStock: null,
        weatherBzj: null,
        moneyBzj: null,
        platformRatio: null,
        contactsName: null,
        contactsPhone: null,
        contactsEmail: null,
        contactsCardNo: null,
        contactsCardHand: null,
        contactsCardFront: null,
        contactsCardContrary: null,
        businessLicenceNumber: null,
        companyName: null,
        companyAreap: null,
        companyAreac: null,
        companyAreax: null,
        companyAddressDetail: null,
        socialCreditCode: null,
        authCertificate: null,
        businessSphere: null,
        businessLicenceNumberElectronic: null,
        bankCardNoType: null,
        settlementBankUserName: null,
        settlementBankAccountNumber: null,
        bankUserPhone: null,
        settlementBankAccountName: null,
        settlementBankName: null,
        settlementBankAddress: null,
        accountInstCity: null,
        accountInstProvince: null,
        createTime: null,
        remark: null,
        trademarkCertificate: null,
        shopProtocol: null,
        businessLicense: null
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    async handleUpdate(id) {
      this.reset()
      this.formType = 2
      this.getCategoryList()
      getShop({"id": id}).then(response => {

        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.按钮.绑定运营公司')
        //回显出分类
        console.log(this.categoryList, response.data.categoryList, response.data.categoryListId)

        this.categorySelected = response.data.categoryList.map(item => String(item))
        console.log(1111111, this.form, this.categoryList)
        return
        this.categoryList.forEach(e => {
          if (e.children) {
            e.children.forEach(child => {
              if (child.id === this.form.categoryId) {
                this.categorySelected.push(e.id)
                this.categorySelected.push(child.id)
              }
            });
          }
          /*console.log(11111)
          console.log(e.children.children)
          if (e.children.children) {
            e.children.children.forEach(child => {
              if (child.id === this.form.categoryId) {
                this.categorySelected.push(e.id)
                this.categorySelected.push(child.id)
              }
            });
          }*/
        });
      })

    },
    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      } else {
        this.handleImagePreview(file);
      }
    },
    handleGoodsDelete(key) {
      const dataSource = [...this.form.goodsList];
      this.form.goodsList = dataSource.filter(item => item.id !== key);
    },
    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'cate'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'shopLogo', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    // 上传覆盖默认的上传行为
    coverImgUpload1(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'cate'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'shopBackground', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    // 上传覆盖默认的上传行为
    coverImgUpload2(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'cate'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'contactsCardFront', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    // 上传覆盖默认的上传行为
    coverImgUpload3(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'cate'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'contactsCardContrary', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    // 上传覆盖默认的上传行为
    coverImgUpload4(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'cate'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'businessLicenceNumberElectronic', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    coverImgUpload5(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'cate'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'businessLicenceNumber', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    // oss 上传结束
    //多图上传开始
    getUidRandom() {
      return Math.round(Math.random() * 80 + 20)
    },
    // 上传详情覆盖默认的上传行为
    coverImgCaseUploadInfo(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'advert'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.imgCaseList.push({status: 'done', url: res, uid: this.getUidRandom(), name: res})
          console.log(_this.imgCaseList)
          this.form.imgCaseList = []
          _this.imgCaseList.forEach(e => {
            if (e.url !== undefined && e.url !== null && e.url !== '') {
              this.form.imgCaseList.push(e.url);
            }
          })
          _this.$message.success('上传成功')
        })
      })
    },
    // 删除图片
    removeImgCaseFile(file) {
      var fileList = []
      this.imgCaseList.forEach(e => {
        if (e.url !== file.url) {
          fileList.push(e)
        }
      })
      var imgCaseList = []
      this.imgCaseList = fileList
      fileList.forEach(e => {
        imgCaseList.push(e.url)
      })
      this.form.imgCaseList = imgCaseList
    },
    //多图上传结束
    getSettleTypeList() {
      allBrand().then(response => {
        this.categoryList = response.data
      })
    },
    /*页面初始化时获取分类类别*/
    getCategoryList() {
      listShopCategory().then(response => {
        this.categoryList = response.data;
        let children = this.handleTree(response.data, 'id', 'pid')
        console.log('children', children)
        this.categoryList = children
      })
    },
    /*分类的选择*/
    onCategoryChange(value, selectedOptions) {
      this.form.categoryId = value[value.length-1]
    },
    getShopQcListList() {
      listShopQc().then(response => {
        this.shopQcList = response.data
      })
    },
    getTimeOfEntryList() {
      listShopEntry().then(response => {
        this.timeOfEntryList = response.data
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          this.form.categoryListId = this.categorySelected
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateShop(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addShop(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less">
.goods-collapse > .ant-collapse-header {
  color: #007ffd !important;
  background: #e8eef9;
}

.box {
  position: relative;
  background-color: #f7f7f7;
  padding: 0 15px 15px 15px;
  margin-bottom: 15px;
  border-radius: 5px;

  .delSpec {
    position: absolute;
    right: -5px;
    top: -5px;
    color: #f5222d;
    cursor: pointer;
  }
}

</style>